import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

export type BuildInfo = {
  version: string;
  date: Date;
}

@Injectable()
export class BuildInfoService {
  private buildInfo: BuildInfo|null = null;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get the build information from the caches.json file
   */
  public getBuildInfo(): Observable<BuildInfo|null> {
    if (this.buildInfo) {
      return Observable.of(this.buildInfo);
    }

    return this.httpClient.get('./caches.json')
      .map((response: any) => {
        return {
          version: response.databaseVersion,
          date: new Date(response.buildDate)
        };
      })
      .catch(error => {
        console.error('Error fetching build info:', error);
        return Observable.of(null);
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/providers/build-info.service.ts